import { ContainerDiv } from './Container.styles';

interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export default function Container({ className, children }: ContainerProps) {
  return <ContainerDiv className={className}>{children}</ContainerDiv>;
}
